import { api } from 'shared/api'

import { commonIntegrationSchemas } from './schemas'

export const commonIntegrationApi = {
  disconnectIntegration: api.account.createPost({
    url: '/integration/disconnectIntegration',
    schemas: commonIntegrationSchemas.disconnectIntegration,
  }),
  getIntegration: api.account.createGet({
    url: '/integration/getIntegration',
    schemas: commonIntegrationSchemas.getIntegration,
  }),
  connectIntegrationByToken: api.account.createPost({
    url: '/integration/connectIntegrationByToken',
    schemas: commonIntegrationSchemas.connectIntegrationByToken,
  }),
}
